export default "__VITE_ASSET__0abdfb22__"